// --- Payload methods
/**
 * Enum of JSON RPC methods for interacting with the Magic SDK authentication
 * relayer.
 */
export var MagicPayloadMethod;
(function (MagicPayloadMethod) {
    MagicPayloadMethod["LoginWithMagicLink"] = "magic_auth_login_with_magic_link";
    MagicPayloadMethod["LoginWithCredential"] = "magic_auth_login_with_credential";
    MagicPayloadMethod["GetIdToken"] = "magic_auth_get_id_token";
    MagicPayloadMethod["GenerateIdToken"] = "magic_auth_generate_id_token";
    MagicPayloadMethod["GetMetadata"] = "magic_auth_get_metadata";
    MagicPayloadMethod["IsLoggedIn"] = "magic_auth_is_logged_in";
    MagicPayloadMethod["Logout"] = "magic_auth_logout";
    MagicPayloadMethod["UpdateEmail"] = "magic_auth_update_email";
    MagicPayloadMethod["LoginWithMagicLinkTestMode"] = "magic_login_with_magic_link_testing_mode";
    MagicPayloadMethod["LoginWithCredentialTestMode"] = "magic_auth_login_with_credential_testing_mode";
    MagicPayloadMethod["GetIdTokenTestMode"] = "magic_auth_get_id_token_testing_mode";
    MagicPayloadMethod["GenerateIdTokenTestMode"] = "magic_auth_generate_id_token_testing_mode";
    MagicPayloadMethod["GetMetadataTestMode"] = "magic_auth_get_metadata_testing_mode";
    MagicPayloadMethod["IsLoggedInTestMode"] = "magic_auth_is_logged_in_testing_mode";
    MagicPayloadMethod["LogoutTestMode"] = "magic_auth_logout_testing_mode";
    MagicPayloadMethod["UpdateEmailTestMode"] = "magic_auth_update_email_testing_mode";
})(MagicPayloadMethod || (MagicPayloadMethod = {}));
//# sourceMappingURL=json-rpc-types.js.map